import { Trans } from '@lingui/react/macro'
import { Alert, Text } from '@mantine/core'

import { useAuthStore } from '../store/useAuthStore'

export function ImpersonationBanner() {
  const { user } = useAuthStore()

  if (!user?.isImpersonating) {
    return null
  }

  return (
    <Alert
      color="blue"
      variant="filled"
      style={{
        borderRadius: 0,
        flexShrink: 0,
      }}
    >
      <Text size="sm" fw={500}>
        <Trans>
          Test mode: Logged in as {user.firstName} {user.lastName}
        </Trans>
      </Text>
    </Alert>
  )
}
